import React,{useState} from 'react';
import {SBA} from './SBA';
import {Insurance} from './Insurance';
import {Monthly} from './Monthly';

const FeesTab = () => {
  const [selectedTab,setSelectedTab]=useState(1); 
  const [IsFee,setIsFee]=useState(true);
  const [feeData,setFeeData]=useState([]);
  return (
    <>
    <div className="p-2 d-flex">
      <div className="button-container verticalTabButton" >
      <button
          className={`non-gappable-button ${selectedTab===1 ? "selected-non-gappable-button" : "non-gappable-button"}`}
          onClick={()=>{setSelectedTab(1)}}
        >
          Internal
        </button>
   
        <button
          className={`non-gappable-button ${selectedTab===2 ? "selected-non-gappable-button" : "non-gappable-button"}`}
          onClick={()=>{setSelectedTab(2)}}
          disabled
        >
         Monthly
        </button>
        <button
          className={`non-gappable-button ${selectedTab===3 ? "selected-non-gappable-button" : "non-gappable-button"}`}
          onClick={()=>{setSelectedTab(3)}}
          disabled
        >
         Insurance
        </button>
        
      </div>
      <div className='p-2 flex-grow-1'>
      {selectedTab===1 && <>  <SBA IsFee={IsFee} />  </> }
      {selectedTab===2 && <>  <Monthly />  </> }
      {selectedTab===3 && <>  <Insurance />  </> }
      </div>
      </div>
    </>
  )
}

export default FeesTab